import React from 'react';
import Text from '@components/common/text';
import Button from '@components/common/button';
import PositionBookmarkListItem from '@components/common/positionBookmarkListItem';

import { useBookmarkStatus, usePositionBookmarks } from '@repository/bookmark/useBookmark';
import { FontStyle } from '@domain/constant/fontStyle';
import { RouteUrl } from '@utils/routeUtil';
import classnames from 'classnames/bind';
import styles from './positionList.module.scss';
const cx = classnames.bind(styles);

const Empty = () => {
  return (
    <div className={cx('emptyWrapper')}>
      <Text fontStyle={FontStyle.B2_B}>북마크한 포지션이 없습니다</Text>
      <Button
        href={RouteUrl.POSITION}
        styles={{
          padding: '11px 20px',
        }}
      >
        포지션 보러 가기
      </Button>
    </div>
  );
};

const PositionList = () => {
  const { data, isFetched } = usePositionBookmarks();
  const { refetch } = useBookmarkStatus({ enabled: false });

  const positionEls = data?.positionBookmarks?.map((dto, idx) => {
    return (
      <PositionBookmarkListItem
        key={`${dto.sn}_${dto.bookmarkYn}`}
        index={idx}
        data={dto}
        clickAfterBookmarkBtn={() => refetch()}
      />
    );
  });

  if (!isFetched) return null;

  if (!data?.bookmarks.length) return <Empty />;

  return <div className={cx('positionListArea')}>{positionEls}</div>;
};

export default PositionList;
